/**
 * UI Text Constants
 * Contains all UI copy text, modal texts, and dialog configurations
 */

export enum COPYS {
  showHowIsDone = 'Muéstranos como lo has aplicado',
  addEvidencePlaceholder = 'Escribe tu comentario',
  addEvidencePlaceholderEvidence = 'Agrega aquí el link',
  addComent = 'Añade un comentario de este tema...',
  TeamPragmapowers = 'Team Pragmapowers',
  AttachmentDescription = 'Argumentación y links que respaldan el conocimiento y las habilidades del pragmático',
  TotalQualification = 'Calificación total',
  Qualification = 'Calificación',
  Valoration = 'Valoración',
  Score = 'Puntaje',
  PendingValoration = 'Pendiente por valorar',
  HowYouHaveApllied = '¿Cómo lo ha aplicado?',
  PragmaticSelfValoration = 'Autovaloración del pragmático',
  TechnicalPragmapowers = 'Technical Pragmapowers',
  SpecialityNotFoundTechnical = 'Actualmente tu especialidad no cuenta con un un mapa de crecimiento.',
  GoogleSheetsReminder = 'Recuerda que esta información está en el encabezado de Google Sheets que acabas de realizar.',
  EmptyString = '',
  AssesmentNotFound = 'No se encontró la competencia en assessmentPragmapawers',
  CanStartValorate = 'Ya puedes empezar a valorar',
  YourOwnSkills = 'tus propias competencias',
  SkillsOf = 'las competencias de',
  AssessmentResultSended = 'El resultado de la review de crecimiento fue enviado al manager(s)',
  ShouldWaitConfirmation = ' debes esperar su confirmación para finalizar la valoración y notificar al pragmático. Recarga la página para actualizar la respuesta.',
  CantGetMail = 'No se encontraron los resultados',
  CantGetMission = 'Añade una nueva misión',
  Loading = 'Cargando...',
  Validating = 'Validando...',
  LoadingEmailAutoComplete = 'Cargando',
  WriteRecomendations = 'Escribe las recomendaciones...',
  ViewClassroomProfile = 'Ver perfil en Classroom',
  ViewValoration = 'Ver valoración',
  ViewValorationInCourse = 'Ver valoración en curso',
  EndValoration = 'Finalizar valoración',
  ReferenceValueObtained = 'El valor de referencia obtenido es:',
  AproveOrRejectTheComments = 'Podrá optar por aprobar o enviar a revisión los comentarios y la valoración de ',
  SendedByValorator = 'enviada por el valorador',
  NewPragmaticSeniority = 'Nuevo nivel de seniority del pragmático:',
  ActualSeniority = 'Seniority actual:',
  ConfirmNewSeniority = 'Confirma el nuevo nivel de seniority del pragmático',
  ChooseSeniority = 'Elige el seniority',
  SelectSeniority = 'Selecciona seniority',
  ChooseLevel = 'Elige el nivel',
  ConfirmPragmaticInfo = 'Confirma la información del pragmático:',
  RecomendationForPragmatic = 'Recomendaciones para el pragmático:',
  AddParticipantLeaders = 'Añade managers participantes',
  ParticipantLeaders = 'Managers de equipo participantes',
  Participants = 'Participantes:',
  AdditionalObservations = 'Observaciones adicionales: ',
  AddAnEmail = 'Agrega un correo',
  GrowthMapWillBeSent = 'El mapa de crecimiento será enviado a:',
  EndValorationTP = 'Finalizar valoración Team Pragmapowers',
  PilotOfOurDestiny = 'Piloto de nuestro destino',
  DontSwallowWhole = 'No trago entero',
  EffectiveCommunication = 'Comunicación efectiva',
  ResultWillSendto = 'El resultado de los Team Pragmapower será enviado a:',
  SendValorationToPragmatic = 'Enviar valoración al pragmático',
  AddRecommendations = 'Añade recomendaciones al pragmático para enviar el informe',
  WriteRecommandations = 'Escribe aquí las recomendaciones...',
  BackToValoration = 'Regresar a la valoración',
  ApproveValoration = 'Aprobar valoración',
  RejectValoration = 'Enviar a revisión',
  SendValorationToTL = 'Enviar valoración al manager',
  SendReport = 'Enviar informe',
  AchievementsRocket = 'Logros 🚀',
  Evaluated = 'Valorado',
  ToEvaluate = 'Por valorar',
  UnderActualSeniority = 'Por debajo del seniority actual',
  IAEVATitleText = 'Realizar la prueba en IA EVA',
  IAEVAButtonText = 'Empezar prueba →',
  CantChangeSeniority = 'Aún no cumple con los logros solicitados para el cambio de seniority',
  ValoratorNotes = 'Notas valorador',
  GeneralComment = 'Comentario valorador',
  RecomendationForPragmaticTitle = 'Recomendaciones para el pragmático',
  ResendReport = 'Reenviar informe de valoración',
  YouAreAboutTo = 'Estás a punto de',
  Approve = 'aprobar',
  Deny = 'rechazar',
  OneAchievement = 'un logro',
  WillReceiveYourComment = 'recibirá tus comentarios.',
  Achievement = 'Logro',
  SeeMore = 'Ver más',
  StartIaEvaValoration = 'Enviar valoración con IA EVA',
  NextStep = 'Próximo paso',
  Cancel = 'Cancelar',
  Confirm = 'Confirmar',
  Accept = 'Aceptar',
  ReserveTime = 'Reservar horario',
  ScheduleAssessmentConversation = 'Agendar review de crecimiento',
  ScheduleAssessmentConfirmation = 'Todo listo para tu review de crecimiento',
  JustOneMoreStepToFinish = 'Sólo un paso más para terminar',
  ThereAreNoNotes = 'Aún no hay notas.',
  MakeSchedule = 'Agendar review',
  FinishAutovaloration = 'Terminar autovaloración',
  StartAutovaloration = 'Iniciar autovaloración',
  SendApprobation = 'Enviar a aprobación',
  SendResponse = 'Enviar respuesta',
  YourReviewHasBeenCompletedAndIsReadyToBeReviewed = 'Tu valoración ha sido completada y está lista para ser revisada. El valorador aún no la ha enviado al manager. En esta fase, el valorador se asegura de que la información esté completa para que pueda ser revisada correctamente.',
  Responsible = 'Responsable',
  KeepMoving = 'Keep moving',
  PendingFeedbackModalTitle = '¿Descartar los cambios?',
  PendingFeedbackModalDescription = 'Tienes comentarios y enlaces de soporte sin enviar. Si no los envías, se perderán, ya que no se guardan automáticamente.',
  FinalizeAssessmentModalTitle = '¿Estás seguro de finalizar la autovaloración?',
  FinalizeAssessmentModalDescription = 'Al confirmar, tus respuestas serán enviadas y no podrás realizar cambios posteriormente.',
  FinalizeAssessmentAndDiscardSupportsModalDescription = 'Tienes comentarios y soportes sin enviar. Si decides continuar, estos se perderán. Al confirmar, tus respuestas serán enviadas y no podrás realizar cambios posteriormente.',
  PleaseComeBackSomeChangesHaveNotBeenSaved = 'Por favor, regresa. Algunos cambios no se han guardado.',
  GoBack = 'Volver',
  FinishAndDiscardSupports = 'Finalizar y descartar soportes',
  DiscardSupportsAndContinue = 'Descartar soportes y continuar',
  FinishSelfAssessment = 'Finalizar autovaloración',
  GoalCreatedSuccessfully = 'Goal created succesfully',
  ApproveStatus = 'aprobado',
  DenyStatus = 'rechazado',
  ActivityName = 'Nombre de la actividad',
  ActivityNamePlaceholder = 'Ingresa el nombre...',
  ActivityDescription = 'Descripción de la actividad',
  ActivityDescriptionPlaceholder = 'Describe la actividad...',
  Add = 'Agregar',
  Save = 'Guardar',
  DuplicateActivityNameError = 'Ya existe una actividad con el mismo nombre.',
  DuplicateActivityDescriptionError = 'Ya existe una actividad con la misma descripción.',
  AddNewResource = 'Agregar nuevo recurso',
  ResourceLinkPlaceholder = 'Link del recurso',
  ResourceNamePlaceholder = 'Nombre del recurso (opcional)',
  AddResource = 'Agregar recurso',
  AddedResources = 'Recursos agregados',
  ResourceLinkNumber = 'Link recurso No.',
  DuplicateUrlError = 'URL repetida',
  EmptyUrlError = 'La URL no puede estar vacía',
  InvalidUrlError = 'No es una URL válida',
  InvalidRepositoryError = 'Debe ser un enlace válido de GitHub o GitLab',
  MaxResourcesReachedError = 'Alcanzaste el máximo ({max}). Elimina uno para agregar otro.',
  PendingResourceError = 'Tienes un recurso sin agregar. Presiona "Agregar recurso" o borra el texto.',
  EditActivity = 'Editar actividad',
  DeleteFocus = 'Eliminar enfoque',
  AddActivity = 'Agregar actividad',
  LearningActivities = 'Actividades de aprendizaje',
  LearningActivitiesDescription = 'Agrega actividades que ayuden al pragmático a desarrollar este comportamiento.',
  CreateLearningActivity = 'Crear actividad de aprendizaje',
  EditLearningActivity = 'Editar actividad de aprendizaje',
  AddToolsAndActivities = 'Añade las herramientas y actividades',
  EvaluatorCommentTooltip = 'Comportamiento con comentario',
  FileTooltip = 'Comportamiento con adjunto',
  CoreBehaviorTooltip = 'Comportamiento obligatorio para el seniority',
  CoreBehaviorConfigureWeight = 'Comportamiento definido como obligatorio en este seniority. Puedes configurarlo desde el comportamiento.',
  CoreObjetiveTooltip = 'Obligatorio para el crecimiento',
  Core = 'Core',
  BehavioralLine = 'Línea comportamental',
  CoreBehaviorsSeniorityTooltip = '{total} comportamientos en total, {core} definidos como obligatorios para este seniority.',
  CoreBehaviorsSeniorityTooltipAssessment = 'El pragmático ha dominado {dominated} de {core} comportamiento(s) obligatorio(s) para este seniority.',
}

export const OBJECTIVE_DETAIL_COPIES = {
  backButton: 'Regresar al listado',
  markAsCompleted: 'Marcar como terminado',
  activitiesTitle: 'Actividades de aprendizaje',
  assessment: 'Assessment',
  activityWithDeliverable: 'Actividad con entregables',
  viewActivity: 'Ver actividad',
  completionNotes: 'Todas las actividades completadas.',
  learningActivity: 'Actividad de aprendizaje',
  addActivity: 'Agregar actividad',
  overdueBanner: 'Este objetivo esta vencido',
  startDateLabel: 'Inicio',
  endDateLabel: 'Vence',
  endOfDaySuffix: '23:59',
  editDates: 'Editar fechas',
  editDatesAriaLabel: 'Editar las fechas de inicio y fin del objetivo',
  noScheduleYet: 'Este objetivo no tiene fechas definidas',
  durationLabel: 'Duración',
  durationSuffix: 'días hábiles',
  noDurationYet: 'Sin duración definida',
};

/**
 * Modal de correccion de fechas. Solo lo ven administrador, lider y valorador.
 * El calculo lo hace el backend: aca no se cuenta ningun dia habil.
 */
export const EDIT_OBJECTIVE_DATES_COPIES = {
  title: 'Editar fechas del objetivo',
  description:
    'Al mover la fecha de inicio, la de fin se recorre los mismos días hábiles. Al mover la de fin, el inicio no se toca.',
  startDateLabel: 'Fecha de inicio',
  endDateLabel: 'Fecha de fin',
  datePlaceholder: 'Seleccionar fecha',
  noDateYet: 'Sin definir',
  endBeforeStartError: 'La fecha de fin no puede ser anterior a la de inicio',
  genericError: 'No se pudieron actualizar las fechas',
  successTitle: 'Fechas actualizadas',
  successDescription: 'La ventana de trabajo del objetivo quedó actualizada',
  cancel: 'Cancelar',
  save: 'Guardar',
  saving: 'Guardando...',
  calculatingPreview: 'Calculando...',
};

export enum ASSESSMENT_GENERATE_REPORT_COPYS {
  ConfirmationMessage = 'Al dar clic en <b>enviar informe</b> el pragmático recibirá en su correo el mapa de crecimiento y tú recibirás una copia 🚀',
  ConfirMessage = 'Al dar clic en <b>enviar valoración</b> el pragmático recibirá un correo con su nuevo seniority y el link para ver su valoración en Creci 🚀',
  SendValorationConfirmMessage = 'Al dar clic en <b>enviar valoración</b> el pragmático recibirá un correo con su resultado 🚀',
  TextEvaluationExample = ' * (4) Referente en el desarrollo de este comportamiento y ayuda a otros a adquirirlo.',
  TextEvaluationExampleDontSwallow = ' * (1) Carece de evidencias suficientes que demuestren el desarrollo de este comportamiento.',
  TextEvaluationExampleEffectiveCommunication = '  * (1) Carece de evidencias suficientes que demuestren el desarrollo de este comportamiento.',
  ToolTipRecomendationMessage = 'Añade recomendaciones al pragmático y agrega el correo del manager para enviar el informe',
}

export enum MODAL_COMMENT_COPYS {
  Title = '¿Eliminar comentario?',
  Description = 'Una vez que lo eliminas, desaparece para siempre.',
}

export enum ASSESSMENT_BANNER_COPYS {
  Title = 'Completa los pasos para',
  Subtitle = 'agendar tu review de crecimiento.',
}

export enum GENERAL_COMMS {
  comment = 'Comentario',
  generalComment = 'Comentario General',
}

export enum BEHAVIOR_COMMENTS {
  Assessment = 'Assessment',
  NoComments = 'No hay comentarios aún',
  AddComment = 'Agregar un comentario',
  EditComment = 'Edita tu comentario...',
  WriteComment = 'Escribe un comentario...',
  UserDefault = 'Usuario',
  Edit = 'Editar',
  Delete = 'Eliminar',
  Cancel = 'Cancelar',
  Save = 'Guardar',
  Send = 'Enviar',
  Saving = 'Guardando...',
  Sending = 'Enviando...',
  EmptyComments = 'Aún no hay comentarios que ayuden al pragmático a mejorar este comportamiento, ¿deseas agregar el primero?',
  EmptyCommentsReadOnly = 'Aún no hay comentarios que ayuden al pragmático a mejorar este comportamiento.',
}

export enum BEHAVIOR_EVIDENCE {
  LinkExamples = 'Link ejemplos',
  NoEvidence = 'No hay evidencias para este comportamiento.',
}

export enum scoresButtonText {
  ShowScore = 'Mostrar puntajes',
  HideScore = 'Ocultar puntajes',
}

export const ModalHeaders = {
  MapVersionActivationTime: 'Tiempo de activación de la versión del mapa',
  PublishSuccess: '¡Versión publicada exitosamente!',
} as const;

export const BUTTON_LABELS = {
  ViewMap: 'Ver mapa',
  EditRole: 'Editar rol',
} as const;

export const UI_LABELS = {
  Role: 'Rol',
  Focus: 'Enfoque:',
  EvaluatorType: 'Valorador',
  UnavailableSpaceType: 'Espacio no disponible',
  UnassignedMessage: 'Se habilitará cuando tu manager asigne un valorador.',
  ScheduleButton: 'Confirmar agenda',
  GoBackButton: 'Regresar',
  ContinueButton: 'Continuar',
  AvailableHours: 'Horas disponibles',
  SelectTime: 'Selecciona una hora',
  NextAvailableSpaces: 'Próximos espacios disponibles',
  AddTeamLeaderTitle: 'Agrega a tu manager:',
  AddEmailPlaceholder: 'Agregar un correo',
} as const;

/** Frases del tiempo restante. El backend entrega el numero; aca solo se elige la frase. */
export const REMAINING_DAYS_COPIES = {
  dueToday: 'Vence hoy',
  remainingPrefix: 'Quedan',
  overduePrefix: 'Vencido hace',
  daySingular: 'día hábil',
  dayPlural: 'días hábiles',
};

export const OBJECTIVE_CARD_COPIES = {
  added: 'Agregado',
  viewDetails: 'Ver detalle',
  weight: 'Peso',
  overdueBadge: 'Vencido',
  overdueBadgeAriaLabel: 'Este objetivo esta vencido',
  completedChip: 'Completado',
};

export const PRAGMAPOWER_LABELS = {
  TechnicalPragmapower: 'Technical Pragmapower',
  TeamPragmapower: 'Team Pragmapower',
  Evaluated: 'Valorado',
  ToEvaluate: 'Por valorar',
  CloseModal: 'Cerrar modal de información',
  DescriptionTitle: 'Descripción',
  CloseButton: 'Cerrar',
  SelectScore: 'Seleccionar puntuación',
  Previous: 'Anterior',
  Next: 'Siguiente',
  Behavior: 'Comportamiento',
  PreviousPragmapower: 'Pragmapower anterior',
  NextPragmapower: 'Siguiente pragmapower',
  ExpandSidePanel: 'Expandir panel lateral',
  CollapseSidePanel: 'Colapsar panel lateral',
  CloseModalEvaluation: 'Cerrar modal',
  InfoIcon: 'Ver información del pragmapower',
  SeniorityBehavior: 'Seniority del comportamiento',
  EvaluatorComments: 'Comentarios valorador',
  HowApplied: '¿Cómo lo ha aplicado?',
  ActualSeniority: 'Seniority actual',
  SeniorityResult: 'Resultado del seniority',
  ScoreLabel: 'Puntaje:',
};

export const EVALUATOR_VALORATION_LABELS = {
  PragmaticInformation: 'Información del pragmático',
  CheckFormIcon: 'check svg',
};
